/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';
import { Link } from 'react-router-dom';

import { StatusIcon } from '../../../components/SVGIcon';
import styled from 'styled-components';

import Localized from '../../../../shared/components/Localized';

import styles from '../../../styles';

const StyledLink = styled(Link)`
  display: flex;
  position: relative;
  text-align: center;
  border: 0.0625rem solid ${styles.colors.geyser};
  height: 44px;
  border-radius: 0.25rem;
  margin-bottom: 1rem;

  padding-left: 12px;
  padding-right: 12px;

  justify-content: space-between;
  align-items: center;

  @media (min-width: 768px) {
    /* Evenly grow and shrink, auto means look at width rules */
    flex: 1 1 auto;
    margin-right: 1rem;
  }

  @media (max-width: 767px) {
    width: 100%;
    margin-right: 0rem;
  }

  &:hover {
    background-color: #F0F8FC;
    text-decoration: none;
  }
`;

const Label = styled.label`
  color: #54698D;
  font-size: 0.75rem;
  line-height: 0.75rem;
  cursor: pointer;
`;

const statusIconMap = {
  OK: 'healthy',
  MAJOR_INCIDENT_CORE: 'major',
  MINOR_INCIDENT_CORE: 'minor',
  MAINTENANCE_CORE: 'maintenance',
  MAJOR_INCIDENT_NONCORE: 'healthy-major',
  MINOR_INCIDENT_NONCORE: 'healthy-minor',
  MAINTENANCE_NONCORE: 'healthy-maintenance',
};

export class InstanceTile extends React.Component {
  static propTypes = {
    instance: PropTypes.shape({
      key: PropTypes.string,
      environment: PropTypes.string
    }).isRequired,
  };

  render() {
    const { instance, displayText } = this.props;
    let url = instance.alias ? ('/alias/' + instance.alias) : ('/instances/' + instance.key);
    const type = typeof instance.aliasType !== 'undefined' && instance.aliasType || '';
    if(type && type !== 'domain') url += `?type=${type}`;
    return (
      <StyledLink to={url} key={instance.key}>
        <Label>
          <Localized modelName={'instance'} modelKey={ displayText } modelAttribute={'label'} />
        </Label>
        <StatusIcon size='1rem' severity={ statusIconMap[instance.status] } />
      </StyledLink>
    );
  }
}
